import React from "react";
import { SidebarCol } from "../chatMain/Sidebar/Sidebar";
import { HomeMaincontent } from "./HomeMaincontent";
import { MainHeader } from "../chatMain/MainHeader/MainHeader";
import { Box } from "@mui/material";
import "./Home.css";

export const Home = () => {
  return (
    <div className="Home-dashboard">
      <div className="sidebar-home">
        <SidebarCol />
      </div>
      <div className="maincontentarea-home">
        <Box sx={{ position: "sticky", top: 0, zIndex: 1000, width: "100%" }}>
          <MainHeader
            titleText="User Statistics"
            subtitleText="Track Your Well-Being Progress"
          />
        </Box>
        <HomeMaincontent />
      </div>
    </div>
  );
};
